import { Flex } from '@chakra-ui/react';
import { coreColors } from '@utils/index';
import Card from './Card';

const Carousel = ({ agents, onButtonClick, playingIndex, setPlayingIndex, ...rest }) => {
  return (
    <Flex
      py={[10]}
      overflowX="scroll"
      w={['100%', '100%', agents.length * 100 + 20]}
      sx={{
        '::-webkit-scrollbar': {
          display: 'none',
        },
      }}
      {...rest}
    >
      {agents.map((agent, index) => {
        return (
          <Card
            video
            index={index}
            key={index}
            agent={agent}
            playingIndex={playingIndex}
            setPlayingIndex={setPlayingIndex}
            onButtonClick={onButtonClick}
            borderColor={coreColors[index % coreColors.length]}
          />
        );
      })}
    </Flex>
  );
};

export default Carousel;
